export const store = {
  getters: {},
  dispatch() {
    console.warn('store.dispatch is not implemented');
  },
};
